import { RootState } from "redux/rootReducer";

export const selectIsSettingInformation = (state: RootState) =>
  state.settingInformation.loading;
export const selectSettingInformationErrorMessage = (state: RootState) =>
  state.settingInformation.error;
export const settingInformationDataResponse = (state: RootState) =>
  state.settingInformation.settingInformationResponse;
